/**
 * Cognito pool configuration.
 *
 * HA-430: these values used to be hardcoded constants. After the AWS account
 * migration that left the deployed frontend authenticating against the RETIRED
 * account's user pool while its API calls went to the new one — a half-migrated
 * state that nothing detected, because the API responded, the site served, and
 * CORS passed. Signups were being written into the account being torn down.
 *
 * They now come from the build's .env file, the same way HEALIO_API_URL does,
 * so an environment is described in one place instead of two.
 *
 * NOTE: the API must validate tokens against the SAME pool (see
 * appsettings.*.json, Cognito.UserPoolId and CognitoJWKS). A frontend pointed
 * at one pool and an API validating another produces a 401 on every
 * authenticated request, with nothing in either log naming the mismatch.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `${name} is not set. Cognito configuration is read from the .env file ` +
        `selected by the build (see rspack.config). Add ${name} to that file — ` +
        `there is deliberately no default, because a wrong pool silently ` +
        `authenticates against the wrong AWS account (HA-430).`
    );
  }
  return value;
}

export const poolData = {
  UserPoolId: required('COGNITO_USER_POOL_ID', process.env.COGNITO_USER_POOL_ID),
  ClientId: required('COGNITO_CLIENT_ID', process.env.COGNITO_CLIENT_ID),
  Region: required('COGNITO_REGION', process.env.COGNITO_REGION),
};
